module.exports = __webpack_public_path__ + "static/media/server-3.086ffc32.svg";